module.exports = __webpack_public_path__ + "static/img/04.480b395c.jpg";